/**
 * 处理添加购物车操作
 */
if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();
                this.form = this.querySelector('form');
                if(!this.form) return;

                this.isloading = false;
                this.error = false;
                this.variantIdInput.disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this)); // 添加提交购物车监听

                this.addCartButtons = this.querySelectorAll('button[type="submit"]'); // 添加购物车按钮，可能有多处按钮

                this.cartDrawer = document.getElementById('Cart-Drawer');
                if (this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) this.addCartButtons.forEach(button=>{
                    button.setAttribute('aria-haspopup', 'dialog');
                    button.setAttribute('aria-expanded', 'false');
                    button.setAttribute('aria-controls', 'Cart-Drawer');
                });

                this.errorMessageWrapper = document.getElementById(`Product-Form-Error-Message-${this.dataset.section}`);
                // 快速购物弹窗
                this.quickAddDrawer = this.closest('product-side-drawer');

                // 迷你结账
                this.miniChecker = document.getElementById(`Product-Mini-Checkout-${this.dataset.section}`);
                if(this.miniChecker) {
                    this.miniCheckerObserver = new IntersectionObserver((entries, observer)=>{
                        if(entries[0].isIntersecting) {
                            this.hideMiniCheck();
                        } else if (entries[0].boundingClientRect.top < 0){
                            this.showMiniCheck();
                        }
                    }, {
                        root: null,
                        rootMargin: '-200px 0px 0px 0px'
                    });

                    this.miniCheckerObserver.observe(this);
                }
            }

            disconnectedCallback() {
                if(this.miniCheckerObserver) this.miniCheckerObserver.disconnect();
            }

            get variantIdInput() {
                return this.form.querySelector('[name=id]');
            }
            
            /**
             * 是否隐藏错误信息
             * 当产品是礼品卡的时候，隐藏错误信息
             * @returns {boolean}
             */
            get hideErrors() {
                return this.dataset.hideErrors === 'true';
            }

            /**
             * 处理点击提交购物车
             * @param event
             */
            async onSubmitHandler(event) {
                if (this.isloading) return;
                event.preventDefault();

                const form = document.querySelector('.bday_card, .wedding_card, .griha_pravesh_card, .rice_ceremony_card, .bachelore_party_card, .dinner_party_card');

                if (form && !this.validateForm(form)) {
                    return false;
                }

                if (Array.from(this.addCartButtons).find(button => button.hasAttribute('disabled'))) return;

                this.clearErrorMessage();

                const isValidDigitalCard = await this.validateDigitalConflict();
                if (!isValidDigitalCard) {
                    return false;
                }

                this.handleErrorMessage();
                this.startLoading();

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData(this.form);
                formData.append('sections', this.getSectionsToRender().map((section) => section.section).join());
                formData.append('sections_url', window.location.pathname);
                config.body = formData;

                fetch(`${window['routes']['cart_add_url']}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);
                            return this.error = true;
                        }
                        this.error = false;

                        SectionDynamicUpdate.updateSections(this.getSectionsToRender(), response['sections']);

                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            cartData: response,
                        });

                        if (this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) {
                            this.cartDrawer.show(event.submitter);
                        } else {
                            return window.location = window['routes']['cart_url'];
                        }
                    })
                    .catch((e) => {
                        this.handleErrorMessage(window['variantStrings']['unknownError']);
                        this.error = true;
                    })
                    .finally(() => {
                        this.endLoading();
                        this.hideMiniCheck();
                    });
            }

            async validateDigitalConflict() {
                try {
                    const currentProductTags = this.getCurrentProductTags();
                    const currentHasDigitalTag = currentProductTags.includes('DigitalProduct');
                    const cartItems = await this.getCartItems(true);
                    if (!cartItems || cartItems.length === 0) {
                        return true;
                    }
                    for (let item of cartItems) {
                        let productData;
                        try {
                            const response = await fetch(`/products/${item.handle}.js`);
                            productData = await response.json();
                        } catch (err) {
                            continue;
                        }
                        const itemTags = productData.tags || [];
                        const itemHasDigitalTag = itemTags.includes('DigitalProduct');

                        if (currentHasDigitalTag && !itemHasDigitalTag) {
                            this.showErrorOnCurrentProduct('Cannot add digital product with non-digital items in cart.');
                            return false;
                        }
                        if (!currentHasDigitalTag && itemHasDigitalTag) {
                            this.showErrorOnCurrentProduct('Cannot add non-digital items with digital product in cart.');
                            return false;
                        }
                    }
                    return true;
                } catch (error) {
                    return true;
                }
            }

            clearErrorMessage() {
                const errorSelectors = [
                    '.product-form__error-message',
                    '.error-message',
                    '.alert-message',
                    '[data-error-message]'
                ];

                const productContainer = this.form.closest('product-form, product-card, .product-card, .product-form, [data-product-form]');

                if (productContainer) {
                    errorSelectors.forEach(selector => {
                        const errorElements = productContainer.querySelectorAll(selector);
                        errorElements.forEach(element => {
                            element.style.display = 'none';
                            element.textContent = '';
                            element.setAttribute('hidden', 'true');
                        });
                    });
                }

                const dynamicErrors = document.querySelectorAll('.product-form__error-message[style*="color: red"]');
                dynamicErrors.forEach(error => {
                    if (error.closest('product-form, product-card, .product-card, .product-form, [data-product-form]') === productContainer) {
                        error.style.display = 'none';
                        error.textContent = '';
                    }
                });
            }

            showErrorOnCurrentProduct(message) {
                this.clearErrorMessage();

                let popup = this.form.closest('product-form').querySelector('.faq-item');
                let errorContainer = this.form.closest('product-form').querySelector('.alert-message');

                if (!errorContainer) {
                    const productCard = this.form.closest('product-card, .product-card, .product-form, [data-product-form]');
                    if (productCard) {
                        errorContainer = productCard.querySelector('.product-form__error-message, .error-message, [data-error-message]');
                    }
                }


                errorContainer.textContent = message;
                errorContainer.style.display = 'block';
                errorContainer.removeAttribute('hidden');

                if (popup) {
                    errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }

                this.currentErrorContainer = errorContainer;

                if (this.errorTimeout) {
                    clearTimeout(this.errorTimeout);
                }

                this.errorTimeout = setTimeout(() => {
                    if (errorContainer) {
                        errorContainer.style.display = 'none';
                        this.currentErrorContainer = null;
                    }
                }, 8000);
            }
            getCurrentProductTags() {
                const productCard = this.form.closest('product-card') || this.form.closest('product-form');

                if (productCard) {
                    const productTagsInput = productCard.querySelector('input[name="product_tags"]');
                    if (productTagsInput && productTagsInput.value) {
                        return productTagsInput.value.split(',').map(tag => tag.trim()).filter(tag => tag);
                    }
                }
                return [];
            }
            async getCartItems(forceRefresh = false) {
                if (!forceRefresh) {
                    if (window.cart && window.cart.items) {
                        return window.cart.items;
                    }

                    if (window.theme && window.theme.cart && window.theme.cart.items) {
                        return window.theme.cart.items;
                    }

                    if (this.cartDrawer && this.cartDrawer.cart) {
                        return this.cartDrawer.cart.items || [];
                    }

                    if (typeof Shopify !== 'undefined' && Shopify.cart) {
                        return Shopify.cart.items || [];
                    }
                }

                try {
                    const cartUrl = window['routes']['cart_url'] || '/cart';
                    const timestamp = forceRefresh ? `?t=${Date.now()}` : '';

                    const response = await fetch(`${cartUrl}.js${timestamp}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Cache-Control': forceRefresh ? 'no-cache' : 'default'
                        }
                    });
                    if (response.ok) {
                        const cartData = await response.json();
                        window.cart = cartData;
                        return cartData.items || [];
                    }
                } catch (e) {
                    console.error('Error fetching cart data:', e);
                }

                return [];
            }

            init() {
                if (typeof PUB_SUB_EVENTS !== 'undefined') {
                    document.addEventListener('shopify:section:load', () => {
                        this.clearErrorMessage();
                    });
                    document.addEventListener('cart:updated', () => {
                        this.clearErrorMessage();
                    });
                    if (window.cart) {
                        let cartItemCount = window.cart.item_count || 0;
                        setInterval(() => {
                            if (window.cart && window.cart.item_count !== cartItemCount) {
                                cartItemCount = window.cart.item_count;
                                this.clearErrorMessage();
                            }
                        }, 1000);
                    }
                }
            }
            
            validateForm(form) {
                let isValid = true;
                let errors = [];
                
                // Comprehensive field name mapping for clean error messages
                const fieldNames = {
                    // Birthday Card Fields
                    'bday_customer_mobile': 'Customer Mobile Number',
                    'bday_send_to_email': 'Email to Send Final Product',
                    'bday_birthday_person': 'Birthday Person\'s Name',
                    'bday_custom_image': 'Birthday Person\'s Image',
                    'bday_custom_address': 'Address',
                    'bday_rsvp_phone': 'RSVP Phone',
                    'bday_event_date': 'Event Date',
                    'bday_event_time': 'Event Time',
                    
                    // Wedding Card Fields
                    'wedding_send_to_email': 'Email to Send Final Product',
                    'wedding_groom_name': 'Groom\'s Name',
                    'wedding_bride_name': 'Bride\'s Name',
                    'wedding_venue': 'Wedding Venue',
                    'wedding_event_date': 'Wedding Date',
                    'wedding_event_time': 'Wedding Time',
                    
                    // Griha Pravesh Card Fields
                    'griha_send_to_email': 'Email to Send Final Product',
                    'griha_venue': 'Venue',
                    'griha_event_date': 'Event Date',
                    'griha_event_time': 'Event Time',
                    
                    // Rice Ceremony Card Fields
                    'rice_send_to_email': 'Email to Send Final Product',
                    'rice_baby_name': 'Baby\'s Name',
                    'rice_custom_image': 'Baby\'s Image',
                    'rice_custom_address': 'Address',
                    'rice_rsvp_phone': 'RSVP Phone',
                    'rice_event_date': 'Event Date',
                    'rice_event_time': 'Event Time',
                    
                    // Bachelor Party Card Fields
                    'bachelor_send_to_email': 'Email to Send Final Product',
                    'bachelor_custom_image': 'Party Image',
                    'bachelor_custom_address': 'Address',
                    'bachelor_rsvp_phone': 'RSVP Phone',
                    'bachelor_event_date': 'Event Date',
                    'bachelor_event_time': 'Event Time',
                    
                    // Dinner Party Card Fields
                    'dinner_send_to_email': 'Email to Send Final Product',
                    'dinner_custom_address': 'Address',
                    'dinner_event_date': 'Event Date',
                    'dinner_event_time': 'Event Time',
                    
                    'customer_mobile': 'Customer Mobile Number',
                    'send_to_email': 'Email to Send Final Product',
                    'birthday_person': 'Birthday Person\'s Name',
                    'custom_image': 'Image',
                    'custom_address': 'Address',
                    'rsvp_phone': 'RSVP Phone',
                    'event_date': 'Event Date',
                    'event_time': 'Event Time',
                    'groom_name': 'Groom\'s Name',
                    'bride_name': 'Bride\'s Name',
                    'venue': 'Venue',
                    'baby_name': 'Baby\'s Name'
                };
            
                form.querySelectorAll('[required]').forEach(field => {
                    const isEmpty = field.type === 'file' ? !field.files.length : !field.value.trim();
                    
                    if (isEmpty) {
                        isValid = false;
                        field.classList.add('error-input');
                        const name = fieldNames[field.id] || 
                                     field.previousElementSibling?.innerText?.replace('*', '').trim() || 
                                     field.id.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                        errors.push(`${name} is required`);
                    } else {
                        field.classList.remove('error-input');
                    }
                });
            
                // Email validation for all email fields
                const emailFields = form.querySelectorAll('input[type="email"]');
                emailFields.forEach(email => {
                    if (email.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
                        isValid = false;
                        email.classList.add('error-input');
                        const fieldLabel = fieldNames[email.id] || 'Email';
                        errors.push(`${fieldLabel} format is invalid`);
                    }
                });
            
                // Mobile validation for all mobile number fields
                const mobileFields = form.querySelectorAll('input[id*="mobile"], input[id*="phone"]');
                mobileFields.forEach(mobile => {
                    if (mobile.value && !/^[0-9]{10}$/.test(mobile.value)) {
                        isValid = false;
                        mobile.classList.add('error-input');
                        const fieldLabel = fieldNames[mobile.id] || 'Phone Number';
                        errors.push(`${fieldLabel} must be 10 digits`);
                    }
                });
            
                // Date validation - ensure date is not in the past
                const dateFields = form.querySelectorAll('input[type="date"]');
                const today = new Date().toISOString().split('T')[0];
                dateFields.forEach(dateField => {
                    if (dateField.value && dateField.value < today) {
                        isValid = false;
                        dateField.classList.add('error-input');
                        const fieldLabel = fieldNames[dateField.id] || 'Event Date';
                        errors.push(`${fieldLabel} cannot be in the past`);
                    }
                });
            
                // File size validation for image uploads (max 5MB)
                const fileFields = form.querySelectorAll('input[type="file"]');
                fileFields.forEach(fileField => {
                    if (fileField.files.length > 0) {
                        const file = fileField.files[0];
                        const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                        
                        if (file.size > maxSize) {
                            isValid = false;
                            fileField.classList.add('error-input');
                            const fieldLabel = fieldNames[fileField.id] || 'Image';
                            errors.push(`${fieldLabel} must be less than 5MB`);
                        }
                        
                        // Check file type
                        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
                        if (!allowedTypes.includes(file.type)) {
                            isValid = false;
                            fileField.classList.add('error-input');
                            const fieldLabel = fieldNames[fileField.id] || 'Image';
                            errors.push(`${fieldLabel} must be a valid image format (JPEG, PNG, GIF, WebP)`);
                        }
                    }
                });
            
                if (!isValid) {
                    this.showErrors(errors, form);
                }
            
                return isValid;
            }
            
            showErrors(errors, form) {
                // Open form details
                const wrapper = document.querySelector('.digital_wrapper details');
                if (wrapper) wrapper.open = true;
            
                // Remove existing errors
                document.querySelector('.form-error-messages')?.remove();
            
                // Create and show error message
                const errorDiv = document.createElement('div');
                errorDiv.className = 'form-error-messages';
                errorDiv.innerHTML = `
                    <div style="background-color: #fee2e2; border: 1px solid #fca5a5; color: #dc2626; padding: 12px; margin: 15px 0; border-radius: 6px; font-size: 14px;">
                        <strong style="display: block; margin-bottom: 8px;">Please fill out the below fields:</strong>
                        <ul style="margin: 0; padding-left: 20px; line-height: 1.5;">
                            ${errors.map(msg => `<li style="margin-bottom: 4px;">${msg}</li>`).join('')}
                        </ul>
                    </div>
                `;
                
                form.insertBefore(errorDiv, form.firstChild);
                errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
            
                // Add real-time error clearing
                form.querySelectorAll('input, textarea').forEach(field => {
                    const clearError = () => {
                        if (field.classList.contains('error-input')) {
                            field.classList.remove('error-input');
                            // Remove error message if no more errors exist
                            if (!form.querySelector('.error-input')) {
                                document.querySelector('.form-error-messages')?.remove();
                            }
                        }
                    };
                    
                    field.addEventListener('input', clearError);
                    field.addEventListener('change', clearError);
                });
            
                setTimeout(() => {
                    const successMessage = document.querySelector('.form-success-message');
                    if (successMessage) {
                        successMessage.style.opacity = '0';
                        setTimeout(() => successMessage.remove(), 300);
                    }
                }, 5000);
            } 

            /**
             * 获取需要重新渲染的位置
             * @returns {[{section: string, selector: string, id: string}]}
             */
            getSectionsToRender() {
                const sections = [
                    {
                        id: 'Cart-Icon-Bubble',
                        section: 'cart-icon-bubble',
                        selector: '.shopify-section'
                    }
                ];

                if(this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) {
                    sections.push({
                        id: 'Cart-Drawer',
                        section: this.cartDrawer.dataset.section,
                        selector: '#Cart-Drawer-Details',
                    });
                }

                return sections;
            }

            /**
             * 错误显示
             * @param errorMessage
             */
            handleErrorMessage(errorMessage = null) {
                if (this.hideErrors || !this.errorMessageWrapper) return;

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
                this.errorMessageWrapper.textContent = errorMessage ? errorMessage : '';
            }

            startLoading() {
                this.isloading = true;

                this.addCartButtons.forEach(button => {
                    button.setAttribute('disabled', 'disabled');
                    button.classList.add('loading');
                });
            }

            endLoading() {
                this.isloading = false;

                this.addCartButtons.forEach(button => {
                    button.removeAttribute('disabled');
                    button.classList.remove('loading');
                });

                // 关闭快速预览
                if(!this.error && this.quickAddDrawer) {
                    this.quickAddDrawer.hide();
                }
            }

            showMiniCheck() {
                if(this.miniChecker) this.miniChecker.classList.add('active');
            }

            hideMiniCheck() {
                if(this.miniChecker) this.miniChecker.classList.remove('active');
            }
        }
    );
}
